export default {
    ARE_MORE_ENTITY:'Do you have more {{role}} to add?',
    ADDED_ENTITY:'{{role}} added!',
}